import { listenDOMEvent } from '@jspartials/dom-api-utils';

const selector = {
  carousel: {
    wrapper: '.js-recommendations__carousel-wrapper',
    self: '.js-recommendations__carousel',
    item: '.js-recommendations__carousel-item',
    nextBtn: '.js-recommendations__carousel-button-next',
    prevBtn: '.js-recommendations__carousel-button-prev'
  }
};

function initCarousel(options) {
  const wrapper = options.wrapper || document.createElement('div');
  const maxVisibleItems = options.maxVisibleItems || 4;
  const carousel = wrapper.querySelector(selector.carousel.self);

  if (carousel) {
    carousel.style.setProperty(
      '--recommendations-max-visible-items',
      maxVisibleItems
    );
    const carouselWrapper = wrapper.querySelector(selector.carousel.wrapper);
    const searcherNextBtn = wrapper.querySelector(selector.carousel.nextBtn);
    const searcherPrevBtn = wrapper.querySelector(selector.carousel.prevBtn);

    if (searcherNextBtn && searcherPrevBtn) {
      listenDOMEvent(carouselWrapper, 'mouseenter', () => {
        showCarouselArrow(wrapper);
      });

      listenDOMEvent(searcherNextBtn, 'click', () => {
        moveElementOfCarousel('right', wrapper);
      });

      listenDOMEvent(searcherPrevBtn, 'click', () => {
        moveElementOfCarousel('left', wrapper);
      });
    }
  }
}

function moveElementOfCarousel(direction, wrapper) {
  const carousel = wrapper.querySelector(selector.carousel.self);
  const carouselItem = wrapper.querySelector(selector.carousel.item);
  let distance = carouselItem.clientWidth + 16;

  if (direction === 'left') {
    distance = -distance;
  }

  toggleArrowVisibility(carousel, distance, wrapper);

  carousel.scrollBy({
    top: 0,
    left: distance,
    behavior: 'smooth'
  });
}

function toggleArrowVisibility(carousel, distance, wrapper) {
  const searcherNextBtn = wrapper.querySelector(selector.carousel.nextBtn);
  const searcherPrevBtn = wrapper.querySelector(selector.carousel.prevBtn);
  const finalDistance = carousel.scrollLeft + distance;
  const carouselWidth = carousel.scrollWidth - carousel.clientWidth;

  if (finalDistance > 0) {
    searcherPrevBtn.style.opacity = 1;
    searcherPrevBtn.disabled = false;
    searcherPrevBtn.style.cursor = 'pointer';
  }
  if (finalDistance <= 0) {
    searcherPrevBtn.style.opacity = 0.5;
    searcherPrevBtn.disabled = true;
    searcherPrevBtn.style.cursor = 'not-allowed';
  }
  // Scroll right ends
  if (finalDistance >= carouselWidth) {
    searcherNextBtn.style.opacity = 0.5;
    searcherNextBtn.disabled = true;
    searcherNextBtn.style.cursor = 'not-allowed';
  } else {
    searcherNextBtn.style.opacity = 1;
    searcherNextBtn.disabled = false;
    searcherNextBtn.style.cursor = 'pointer';
  }
}

function showCarouselArrow(wrapper) {
  toggleArrowVisibility(
    wrapper.querySelector(selector.carousel.self),
    0,
    wrapper
  );
}
export { initCarousel };
